export const getSecureWebDomain = () => {
  if (window.location.hostname === 'localhost') {
    return 'sys-ib'
  }
  switch (
    window.location.hostname.substring(0, window.location.hostname.indexOf('.'))
  ) {
    case 'sys':
      return 'sys-ib'
    case 'acc':
      return 'acc-ib'
    case 'preprod':
      return 'preprod-ib'
    case 'www':
    default:
      return 'secure'
  }
}

/**
 * If we want to improve this we can:
 * - add a dynamic interest rate  (similar to the one you can take from curl -X GET https://www.sbab.se/api/interest-account-service/api/external/v1/products | jq ".products[] | select(.type == \"savings_account\") | .accountProductItems[].interestRate")
 * - assume that the money already saved also is moved into a savings account with the same interest rate
 * - correct the calculation, probably with a loop instead.
 * @param goal what to reach
 * @param amountPerMonth how much can be saved per month.
 * @returns {number} how many months it will take to reach the goal given the amount saved per month.
 */
export const calculateMonthsToReachGoal = (goal, amountPerMonth) => {
  const months = Math.ceil(goal / amountPerMonth);
  if (months > 600) {
    return months; // when dealing with large numbers, the withInterest calculation will fail, so it's better to just return the months without considering the interest.
  }
  const withInterest = Math.pow(1.005, months / 12) * amountPerMonth
  return Math.ceil(goal / withInterest)
}